import { IEventV2, IEventV3 } from '../../data/entities/event';

export const isoDateToUtcDateString = (aDate: string) => {
	return utcDateFromTimestamp(new Date(aDate).getTime()).toDateString();
};

export const durationInNights = (event: IEventV3 | IEventV2) => {
	const startOnDate = new Date(event.start_on);
	const endOnDate = new Date(event.end_on);
	return endOnDate < startOnDate ? 0
		: Math.abs(Math.round(endOnDate.getTime() - startOnDate.getTime()) / (1000 * 60 * 60 * 24));
};

export const stripTimezone = (isoDateString: string) => {
	return isoDateString ? isoDateString.split('T')[0] : '';
};

/*
	Customers complained booking dates are out by a day. This is because local computer timezones assumed our
	ISO date string from service was in the local time of the computer. This is wrong.

	Start/End dates currently have no timezones - so we need to agree what '2020-01-01' means. And for the sake of
	consistency between front and back end - lets assume UTC - so we can reverse it correctly on the front end.

	This function changes the date objects - created by dates from service - to UTC, the assumed timezone. So we can
	now display it as per what the availability service returns.

	We will want to attach time zones to booking start/end eventually. This is a shorter term fix.
*/
const utcDateFromTimestamp = (timestamp: number) => {
	return new Date(new Date(timestamp).getTime() + (new Date(timestamp).getTimezoneOffset() * 60 * 1000));
};
